var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "folderBrowser",
      on: {
        contextmenu: function($event) {
          $event.stopPropagation()
          $event.preventDefault()
          return _vm.onContextmenu($event)
        }
      }
    },
    [
      _vm.isSearch
        ? _c(
            "div",
            { staticClass: "searchResultsSection" },
            [
              _c(
                "h3",
                { staticClass: "searchingHeading" },
                [
                  _c("vsvg", {
                    staticClass: "searchIcon",
                    attrs: { sprite: "search", role: "presentation" }
                  }),
                  _vm._v("\n\t\t\tSearch Results\n\t\t")
                ],
                1
              ),
              _vm._v(" "),
              _vm.searchArgs.query
                ? [
                    _c("p", [
                      _vm._v('for "'),
                      _c("b", [_vm._v(_vm._s(_vm.searchArgs.query))]),
                      _vm._v('"')
                    ])
                  ]
                : [
                    _c(
                      "p",
                      [
                        _vm._v("for "),
                        _c(
                          "router-link",
                          {
                            attrs: {
                              to: {
                                name: "advancedSearch",
                                query: _vm.$route.query
                              }
                            }
                          },
                          [_vm._v("[advanced query]")]
                        )
                      ],
                      1
                    )
                  ],
              _vm._v(" "),
              _c("div", [
                _vm._v("in "),
                _c("code", { staticClass: "inline" }, [
                  _vm._v(_vm._s(_vm.selectedFolderPath))
                ])
              ]),
              _vm._v(" "),
              _c(
                "div",
                [
                  _c("vsvg", {
                    staticClass: "arrowRight",
                    attrs: { sprite: "arrow_right_alt" }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "router-link",
                {
                  staticClass: "searchResultsClose",
                  attrs: { to: _vm.closeSearchResultsRoute }
                },
                [_vm._v("Close Search Results")]
              )
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.error
        ? _c("div", { staticClass: "error" }, [
            _vm._v("\n\t\t" + _vm._s(_vm.error) + "\n\t\t"),
            _c("div", { staticClass: "tryAgain" }, [
              _c("input", {
                attrs: { type: "button", value: "Try Again" },
                on: { click: _vm.loadFolders }
              })
            ])
          ])
        : _vm.filters_error
        ? _c("div", { staticClass: "error" }, [
            _vm._v(
              "\n\t\tFailed to load filter list. " +
                _vm._s(_vm.filters_error) +
                "\n\t\t"
            ),
            _c("div", { staticClass: "tryAgain" }, [
              _c("input", {
                attrs: { type: "button", value: "Try Again" },
                on: { click: _vm.loadFilters }
              })
            ])
          ])
        : _vm.rootFolder
        ? _c(
            "div",
            [
              _c("FolderNode", {
                ref: "folderNode",
                staticClass: "folderRootNode",
                attrs: {
                  projectName: _vm.projectName,
                  folder: _vm.rootFolder,
                  selectedFolderId: _vm.selectedFolderId,
                  isDialog: _vm.isDialog,
                  dialogAllowsAllFolders: _vm.dialogAllowsAllFolders
                },
                on: {
                  menu: _vm.onMenu,
                  moveInto: _vm.onMoveInto,
                  select: _vm.onFolderSelect
                }
              }),
              _vm._v(" "),
              _vm.loading || _vm.filters_loading
                ? _c("div", { staticClass: "loadingOverlay" }, [
                    _c(
                      "div",
                      { staticClass: "loading" },
                      [_c("ScaleLoader"), _vm._v(" Updating…")],
                      1
                    )
                  ])
                : _vm._e()
            ],
            1
          )
        : _vm.loading || _vm.filters_loading
        ? _c(
            "div",
            { staticClass: "loading" },
            [_c("ScaleLoader"), _vm._v(" Loading…")],
            1
          )
        : _c("div", [
            _vm._v("\n\t\tRoot folder not found.\n\t\t"),
            _c("div", { staticClass: "tryAgain" }, [
              _c("input", {
                attrs: { type: "button", value: "Try Again" },
                on: { click: _vm.loadFolders }
              })
            ])
          ]),
      _vm._v(" "),
      _c("vue-context", {
        ref: "menu",
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function(folder) {
              return [
                folder.data && folder.data.FolderId > -1
                  ? _c("li", [
                      _c("span", { staticClass: "menuComment" }, [
                        _vm._v(_vm._s(folder.data.AbsolutePath))
                      ])
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "li",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: folder.data && folder.data.FolderId >= 0,
                        expression: "folder.data && folder.data.FolderId >= 0"
                      }
                    ]
                  },
                  [
                    _c(
                      "a",
                      {
                        attrs: { role: "button" },
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                            return _vm.newFolder(folder.data)
                          }
                        }
                      },
                      [_vm._v("New Folder")]
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "li",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: folder.data && folder.data.FolderId > 0,
                        expression: "folder.data && folder.data.FolderId > 0"
                      }
                    ]
                  },
                  [
                    _c(
                      "a",
                      {
                        attrs: { role: "button" },
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                            return _vm.beginMoveFolder(folder.data)
                          }
                        }
                      },
                      [_vm._v("Move")]
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "li",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: folder.data && folder.data.FolderId > 0,
                        expression: "folder.data && folder.data.FolderId > 0"
                      }
                    ]
                  },
                  [
                    _c(
                      "a",
                      {
                        attrs: { role: "button" },
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                            return _vm.renameFolder(folder.data)
                          }
                        }
                      },
                      [_vm._v("Rename")]
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "li",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: folder.data && folder.data.FolderId > 0,
                        expression: "folder.data && folder.data.FolderId > 0"
                      }
                    ]
                  },
                  [
                    _c(
                      "a",
                      {
                        attrs: { role: "button" },
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                            return _vm.deleteFolder(folder.data)
                          }
                        }
                      },
                      [_vm._v("Delete")]
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "li",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: folder.data && folder.data.FolderId > -1,
                        expression: "folder.data && folder.data.FolderId > -1"
                      }
                    ]
                  },
                  [
                    _c(
                      "a",
                      {
                        attrs: { role: "button" },
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                            return _vm.setFolderReadState(folder.data, true)
                          }
                        }
                      },
                      [_vm._v("Mark Folder Read")]
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "li",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: folder.data && folder.data.FolderId > -1,
                        expression: "folder.data && folder.data.FolderId > -1"
                      }
                    ]
                  },
                  [
                    _c(
                      "a",
                      {
                        attrs: { role: "button" },
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                            return _vm.setFolderReadState(folder.data, false)
                          }
                        }
                      },
                      [_vm._v("Mark Folder Unread")]
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "li",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: folder.data,
                        expression: "folder.data"
                      }
                    ],
                    staticClass: "v-context__sub"
                  },
                  [
                    _c("a", { attrs: { role: "button" } }, [
                      _vm._v("Run Filter")
                    ]),
                    _vm._v(" "),
                    _c(
                      "ul",
                      { staticClass: "v-context" },
                      [
                        _c("li", [
                          _c(
                            "a",
                            {
                              attrs: { role: "button" },
                              on: {
                                click: function($event) {
                                  $event.preventDefault()
                                  return _vm.runAllEnabledFilters(folder.data)
                                }
                              }
                            },
                            [_c("b", [_vm._v("All Enabled Filters")])]
                          )
                        ]),
                        _vm._v(" "),
                        _vm._l(_vm.filters, function(f) {
                          return f.NumActions > 0
                            ? _c("li", { key: f.filter.FilterId }, [
                                _c(
                                  "a",
                                  {
                                    attrs: { role: "button" },
                                    on: {
                                      click: function($event) {
                                        $event.preventDefault()
                                        return _vm.runFilter(
                                          f.filter,
                                          folder.data
                                        )
                                      }
                                    }
                                  },
                                  [_vm._v(_vm._s(f.filter.Name))]
                                )
                              ])
                            : _vm._e()
                        })
                      ],
                      2
                    )
                  ]
                ),
                _vm._v(" "),
                _vm.nextUndo
                  ? _c("li", [
                      _c(
                        "a",
                        {
                          attrs: { role: "button" },
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              return _vm.undo()
                            }
                          }
                        },
                        [_vm._v("Undo " + _vm._s(_vm.nextUndo.description))]
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.nextRedo
                  ? _c("li", [
                      _c(
                        "a",
                        {
                          attrs: { role: "button" },
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              return _vm.redo()
                            }
                          }
                        },
                        [_vm._v("Redo " + _vm._s(_vm.nextRedo.description))]
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                !_vm.nextUndo && !_vm.nextRedo && !folder.data
                  ? _c("li", [
                      _c("span", { staticClass: "menuComment" }, [
                        _vm._v("no context menu items")
                      ])
                    ])
                  : _vm._e()
              ]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }